import _ from 'lodash';
import isGUID from '../validationHelpers/isGUID';

const formatTripIdForBrochure = (tripId, startDate, endDate, staterooms) => {
  if (!tripId) {
    return '';
  }
  if (isGUID(tripId)) {
    return tripId;
  }
  return (
    tripId +
    (startDate || '').split('T')[0] +
    (endDate || '').split('T')[0] +
    JSON.stringify(
      _.map(staterooms, (stateroom) => ({
        adults: stateroom.adults > 0 ? stateroom.adults : undefined,
        children: stateroom.children?.length > 0 ? stateroom.children : undefined,
        seniors: stateroom.seniors > 0 ? stateroom.seniors : undefined,
        lapInfants: stateroom.lapInfants > 0 ? stateroom.lapInfants : undefined,
        seatInfants: stateroom.seatInfants > 0 ? stateroom.seatInfants : undefined,
      })),
    )
  );
};

export default formatTripIdForBrochure;
